export const SHOPIFY_DATA = {
    product: [],
    click: null,
};

// Product is an object that contains only the following attributes:
// * id
// * title
// * variants
// * img_url
// * ismonthly
export function save_product_data(
    product,
    ispromo,
    position,
    collection_title
) {
    SHOPIFY_DATA.product.push({
        product,
        ispromo,
        position,
        collection_title,
    });
}

// Product is an object that contains only the following attributes:
// * id
// * name
// * category
// * price
// * variant_size
// * variants
export function save_buttonclick_data(product) {
    SHOPIFY_DATA.click = product;
}

// function save_general_data(product, category_name, ispromo, img_url) {
//     SHOPIFY_DATA.general.push({
//         product: product,
//         category: category_name,
//         ispromo: ispromo,
//         img_url: img_url,
//     });
// }
